<script>
  import Routes from './Routes.svelte';
  import Header from './assets/general/header.svelte';
  import Footer from './assets/general/footer.svelte';
</script>

<Header />
<main>
  <Routes />
</main>
<Footer />